import React from 'react';

import PropTypes from 'prop-types';

import HeroHeader from 'wanderu-component-hero-header';

import cityBackgroundImg from 'wanderu-assets/images/seo/city-to-city/hero-header.jpg';

function MultiModalCityToCityHeader(props) {
    const {
        arrivePlace,
        className,
        departDate,
        departPlace,
        destinationPlaceId,
        headerImageUrl,
        hideHotelsAndApps,
        originPlaceId,
        title,
    } = props;

    return (
        <HeroHeader
            backgroundImage={headerImageUrl || cityBackgroundImg}
            className={className}
            showAppDownloadCTA={!hideHotelsAndApps}
            title={title}
            widgetProps={{
                defaultDestinationInput: arrivePlace,
                defaultOriginInput: departPlace,
                departDate,
                destinationPlaceId,
                originPlaceId,
                showClickTripz: !hideHotelsAndApps,
            }}
        />
    );
}

MultiModalCityToCityHeader.propTypes = {
    arrivePlace: PropTypes.string,
    className: PropTypes.string,
    departDate: PropTypes.string,
    departPlace: PropTypes.string,
    destinationPlaceId: PropTypes.string,
    headerImageUrl: PropTypes.string,
    hideHotelsAndApps: PropTypes.bool,
    originPlaceId: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default MultiModalCityToCityHeader;
